module.exports = __webpack_public_path__ + "static/img/title_logo.e2471be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title_logo.png
// module id = S9TZ
// module chunks = 1